// =======================
// 🌍 BASE URL CONFIG
// =======================

// 🔧 Localda ishlasangiz:
// export const BASE_URL = "http://localhost:3001";

// 🚀 Production (online)
export const BASE_URL = "https://aes.fstu.uz";

// =======================
// 🔗 API & FRONTEND
// =======================

export const BASE_API_URL = `${BASE_URL}/api`;     // yagona API root
export const BASE_FRONT_URL = "https://aes.fstu.uz";

// =======================
// 🖼 Image upload
// =======================

export const IMAGE_UPLOAD_URL = `${BASE_API_URL}/upload/image`;

// =======================
// 📂 Menu API endpoints
// (category orqali – moslashuvchan va to‘g‘ri)
// =======================

export const MENU_ENDPOINTS = {
  department: `${BASE_API_URL}/menus?category=THE%20DEPARTMENT`,
  research: `${BASE_API_URL}/menus?category=RESEARCH`,
  teaching: `${BASE_API_URL}/menus?category=TEACHING`,
  academic: `${BASE_API_URL}/menus?category=ACADEMIC%20INFRASTRUCTURE`,
};

// =======================
// 🌐 Language helpers
// =======================

export const getCurrentLanguage = () =>
  localStorage.getItem("language") || "uz";

// =======================
// 📰 News section titles
// =======================

export const NEWS_TEXT = {
  uz: { focus: "Asosiy", aes: "AES Yangiliklari", fstu: "FSTU Yangiliklari" },
  ru: { focus: "Фокус", aes: "Новости AES", fstu: "Новости FSTU" },
  en: { focus: "Focus", aes: "AES News", fstu: "FSTU News" },
};
